import React, { useContext } from 'react';
import styled from 'styled-components';
import { composeValidators, required, validEmail } from '@ubeya/shared/utils/form';
import { FlexSpace, InputField, FormModal } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { isMobileOnly } from 'react-device-detect';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const ContactModal = ({ selectedContact, onClose, onConfirm, contatInitalValues = null }) => {
  const { t } = useContext(ConfigContext);

  const currentContactData = contatInitalValues?.contactName && contatInitalValues?.contactName.split(' ');

  const initalValues = {
    firstName: currentContactData?.[0],
    lastName: currentContactData?.[1],
    ...selectedContact
  };

  return (
    <FormModal
      initialValues={initalValues}
      onSubmit={(values) => {
        onConfirm(Object.entries(values).reduce((prev, [key, value]) => ({ ...prev, [key]: value ?? undefined }), {}));
        onClose();
      }}
      size={isMobileOnly ? 'full' : 'small'}
      onClose={onClose}
      title={selectedContact.id ? t('editContact') : t('addContact')}
      confirmText={t('save')}
      showCancelButton
      isScrollableContent>
      <Container>
        <InputField name="firstName" title={t('firstName')} validate={required} autoFocus />

        <InputField name="lastName" title={t('lastName')} />

        <InputField name="role" title={t('position')} />

        <InputField
          name="email"
          title={t('email')}
          disabled={!!selectedContact.id}
          validate={composeValidators(required, validEmail)}
          readOnly={!!selectedContact?.id}
        />

        <InputField name="phone" title={t('phone')} />
      </Container>
    </FormModal>
  );
};

export default ContactModal;
